










import {Component, Prop, Vue} from 'vue-property-decorator'

import {designStore} from "@/store/store";
import BaseTraffic from "@/modules/design/views/BaseTraffic.vue";
import {Route} from "vue-router";
import {minValue, required} from "vuelidate/lib/validators";
import {createPorousValidations} from "@/modules/design/lib/validations/porous";


@Component({
  components: {
    BaseTraffic
  },
})
export default class PorousTraffic extends Vue {
  @Prop() readonly pxDesignId!: string;
  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentPorous;
  }

  get scenarioImperial() {
    return designStore.currentPorousImperial

  }

  validations(){
    return createPorousValidations(this.scenarioImperial)

  }

  save() {
    this.sync();
    designStore.saveCurrentPorousScenario();
  }

  sync() {
    designStore.setCurrentPorousScenario(this.scenario)
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next()
  }

}

